module.exports = __webpack_public_path__ + "static/img/rank-2.719cfcf1.png";